import { render, staticRenderFns } from "./Connect.vue?vue&type=template&id=2910cfc8&scoped=true&"
import script from "./Connect.vue?vue&type=script&lang=js&"
export * from "./Connect.vue?vue&type=script&lang=js&"
import style0 from "./Connect.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./Connect.vue?vue&type=style&index=1&id=2910cfc8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2910cfc8",
  null
  
)

export default component.exports